'use client'
import { DashboardModule } from '@repo/dashboard/DashboardModule'

const Home = () => {
  return <DashboardModule />
}

export default Home
